<template lang="pug">
  base-content(title="パートナー様用申請書")
    portal(to="navbar-item")
      a.button.is-rounded.is-main-link(:href="guideUrl" target="_blank")
        span.has-text-weight-bold ご利用ガイドはこちら

    base-app-selection(target="p")
</template>

<script>
import BaseContent from '@/components/BaseContent'
import BaseAppSelection from '@/components/BaseAppSelection'
import { guideUrl } from '@/data/config'

export default {
  name: 'partnerAppSelection',
  components: { BaseContent, BaseAppSelection },
  data () {
    return {
      guideUrl: guideUrl || '#'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PartnerAppSelection.vue